import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: {
        Heading: () => <>Schedule</>,
        SubHeading: () => (
            <span>
                Here's what to expect for our wedding. We can't wait
                to celebrate with you!
            </span>
        ),
    },
    [LANGUAGE.ZH]: {
        Heading: () => <>日程</>,
        SubHeading: () => (
            <span>
                这是我们用心准备的行程。我们已经等不及和大家一起庆祝啦！  
               
            </span>
        ),
    },
}
